const context = require.context('../locales', false, /\.json$/)

export default {
  beforeCreate() {
    this.$mergeLocalesToI18n(this.$i18n, context)
  }
}
